const DetectivesPolaroids = () => {
    return (
        <svg width='400' height='280' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fill='#fff' d='M50 40h300v200H50z' />
            <g clipPath='url(#clip0)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M304.806 230.945v-5.754l-10.379.383v7.96h12.974l-2.595-2.589zM284.049 230.945v-5.754l10.378.383v7.96h-12.973l2.595-2.589z'
                    fill='#371F38'
                />
                <path
                    d='M294.733 179.39c2.9 0 5.251 2.302 5.251 5.142v1.077c.816 0 1.477.647 1.477 1.446 0 .799-.661 1.446-1.477 1.446-.065 0-.13-.004-.193-.012-.597 2.1-2.523 3.658-4.836 3.753l-.222.004c-2.41 0-4.441-1.59-5.059-3.758-.062.009-.126.013-.192.013-.816 0-1.477-.647-1.477-1.446 0-.799.661-1.446 1.477-1.446v-1.077c0-2.84 2.351-5.142 5.251-5.142z'
                    fill='#FA8100'
                />
                <path
                    d='M297.359 178.04c2.501.003 2.511 2.231 1.464 3.263l-.001.001c.727.882 1.162 2.005 1.162 3.228l.001 1.081c-1.348-.466-2.359-1.631-2.581-3.05l-.023-.175c-.699.622-1.628 1.002-2.648 1.002-1.019 0-1.948-.38-2.648-1.002l-.023.175c-.221 1.419-1.232 2.584-2.58 3.05v-1.081c0-1.065.331-2.054.897-2.875l.009-.013c.005-.007.01-.015.015-.022.046-.065.093-.129.142-.192l.02-.029c1.659-2.151 5.06-3.363 6.794-3.361z'
                    fill='#371F38'
                />
                <path
                    d='M297.122 190.379v5.178h-5.189v-5.178h5.189zm-25.284-14.121l3.669 3.662-3.669 3.661-3.67-3.661 3.67-3.662zm45.179 0l3.669 3.662-3.669 3.661-3.67-3.661 3.67-3.662z'
                    fill='#FA8100'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M304.806 197.398l2.883 30.67h-26.523l2.883-30.67h20.757z'
                    fill='#119DCB'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M284.049 207.641h20.757v-12.947h-20.757v12.947z'
                    fill='#119DCB'
                />
                <path
                    d='M273.67 181.748l20.757 20.714 20.758-20.714'
                    stroke='#119DCB'
                    strokeWidth='6.3'
                    strokeLinejoin='round'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M289.237 199.78h10.379v-7.768h-10.379v7.768z'
                    fill='#119DCB'
                />
                <path d='M297.022 194.666l-5.189 5.179v23.304' stroke='#371F38' strokeWidth='.933333' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M286.642 181.214h3.269l1.921-5.178h5.189l1.879 5.178h3.31s-2.574 2.59-7.784 2.59c-5.209 0-7.784-2.59-7.784-2.59z'
                    fill='#119DCB'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M270.928 181.748h46.952v-55.486h-46.952v55.486z'
                    fill='#F4F6F8'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M273.399 170.65h40.774v-41.922h-40.774v41.922z'
                    fill='#CDD7E0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M296.861 154.259l-13.46 5.294v-13.247c0-5.856 4.821-10.604 10.769-10.604 5.946 0 10.766 4.748 10.766 10.604 0 4.392-3.615 7.953-8.075 7.953z'
                    fill='#371F38'
                />
                <mask id='a' maskUnits='userSpaceOnUse' x='270' y='126' width='48' height='56'>
                    <path d='M270.928 181.748h46.482v-55.486h-46.482v55.486z' fill='#fff' />
                </mask>
                <g mask='url(#a)' fillRule='evenodd' clipRule='evenodd' fill='#BB5602'>
                    <path d='M291.477 156.365h5.385v-7.357h-5.385v7.357z' />
                    <path d='M294.169 151.658c-2.973 0-5.384-2.373-5.384-5.302v-2.651c0-2.928 2.411-5.301 5.384-5.301 2.974 0 5.384 2.373 5.384 5.301v2.651c0 2.929-2.41 5.302-5.384 5.302z' />
                    <path d='M289.626 146.306c0 .823-.678 1.491-1.514 1.491s-1.514-.668-1.514-1.491c0-.824.678-1.491 1.514-1.491s1.514.667 1.514 1.491zM301.74 146.306c0 .823-.678 1.491-1.514 1.491-.837 0-1.514-.668-1.514-1.491 0-.824.677-1.491 1.514-1.491.836 0 1.514.667 1.514 1.491z' />
                </g>
                <mask id='b' maskUnits='userSpaceOnUse' x='288' y='137' width='13' height='14'>
                    <path
                        d='M288.901 143.112v2.592c0 2.864 2.537 5.184 5.668 5.184 3.13 0 5.667-2.32 5.667-5.184v-2.592c0-2.863-2.537-5.184-5.667-5.184-3.131 0-5.668 2.321-5.668 5.184z'
                        fill='#fff'
                    />
                </mask>
                <g mask='url(#b)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M300.52 137.97c0 3.989-3.536 7.224-7.897 7.224-4.363 0-7.899-3.235-7.899-7.224 0-3.991 3.536-7.226 7.899-7.226 4.361 0 7.897 3.235 7.897 7.226z'
                        fill='#371F38'
                    />
                </g>
                <mask id='c' maskUnits='userSpaceOnUse' x='278' y='153' width='31' height='18'>
                    <path d='M278.975 153.388h29.939v16.949h-29.939v-16.949z' fill='#fff' />
                </mask>
                <g mask='url(#c)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M308.914 173.613h-29.939v-5.395c0-8.19 6.702-14.83 14.97-14.83 8.267 0 14.969 6.64 14.969 14.83v5.395z'
                        fill='#9EEEFD'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M104.578 233.527v-5.754H94.1992v8.343h12.9738l-2.595-2.589z'
                    fill='#371F38'
                />
                <path
                    d='M118.914 214.647l2.595 4.485-4.494 2.589-2.595-4.485 4.494-2.589zm-28.6719 0l4.4941 2.589-2.5948 4.485-4.494-2.589 2.5947-4.485zm15.7469-20.939l2.436 4.572-4.582 2.431-2.436-4.572 4.582-2.431z'
                    fill='#FA8100'
                />
                <path
                    d='M98.0684 184.578c2.1086-1.121 4.6396-.645 6.2016 1.006l3.825 3.112-1.42 1.213c.697 2.259-.237 4.762-2.337 5.993l-.191.107c-2.531 1.345-5.671.389-7.0137-2.136l-1.2156-2.287c-1.3427-2.525-.3798-5.663 2.1507-7.008z'
                    fill='#FA8100'
                />
                <path
                    d='M96.1981 203.168l-4.2546-8.002c-2.3498-4.42-.6647-9.911 3.7638-12.266 4.4287-2.354 9.9237-.681 12.2727 3.739l1.824 3.429c1.343 2.525.38 5.663-2.151 7.009l-1.54-2.899c.737-1.179.983-2.629.635-4.011l-.073-.258 1.42-1.213-3.825-3.112c-.325-.344-.692-.636-1.089-.874l.003-.055c-.068 1.631-.908 3.192-2.35 4.131l-.21.13-.192.107.104.207c.088.183.163.37.228.558-.103.027-.203.067-.301.118-.7113.379-.9823 1.261-.6046 1.972.2666.5.7836.781 1.3146.771.924.308 1.696.956 2.154 1.818l2.035 3.828-9.1639 4.873z'
                    fill='#BB5602'
                />
                <path
                    d='M104.578 201.16c5.068 0 10.357 11.966 12.121 15.033'
                    stroke='#119DCB'
                    strokeWidth='6.3'
                    strokeLinejoin='round'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M94.1992 210.167l18.1628.056s-.714-12.947-7.784-12.947c-7.0702 0-10.3788 12.891-10.3788 12.891z'
                    fill='#119DCB'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M112.362 233.527v-6.619h-10.379v9.208h12.974l-2.595-2.589z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M94.1992 210.167l-2.883 20.483h23.9288l-2.883-20.427-18.1628-.056z'
                    fill='#119DCB'
                />
                <path
                    d='M104.578 201.16c-5.068 0-10.3566 11.966-12.121 15.033'
                    stroke='#119DCB'
                    strokeWidth='6.3'
                    strokeLinejoin='round'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M99.3886 203.864h10.3784v-7.768H99.3886v7.768z'
                    fill='#119DCB'
                />
                <path d='M103.46 199.673l5.189 5.179v23.304' stroke='#371F38' strokeWidth='.933333' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M109.144 185.917l-3.571-.839-4.938-3.04-6.6186 4.088.8404 3.541-.8407 3.565 15.1279-7.315z'
                    fill='#119DCB'
                />
                <path fillRule='evenodd' clipRule='evenodd' d='M49 240h302v-4H49v4z' fill='#CED8E1' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M149.504 131.109l7.781 24.583-4.553 22.808-4.552 22.808.423 35.84h56.826l.01-35.84 4.113-22.808 4.114-22.808-7.781-24.583h-56.381z'
                    fill='#F2F5F7'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M205.43 131.109l7.442 24.583-4.185 22.808-4.185 22.808v35.84h28.233l-.432-35.84 4.633-22.808 4.633-22.808-7.442-24.583H205.43z'
                    fill='#CED8E1'
                />
                <path
                    d='M221.473 232.684l-70.51-.465M219.002 224.053l-70.51-.465M225.179 211.723l-70.509-.465M223.944 217.888l-70.51-.465M228.886 179.664l-70.509-.464M230.122 161.169l-70.51-.464M236.291 170.801l-54.438-.232M225.179 191.994l-70.509-.464M230.122 143.907l-70.51-.464M228.886 153.771l-70.509-.464M219.002 201.858l-70.51-.464M228.886 198.159l-70.509-.464'
                    stroke='#CED8E1'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M146.276 134.387l2.878 10.742 53.594-14.361-2.878-10.741-53.594 14.36z'
                    fill='#ECEDEE'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M157.146 132.081l2.499 9.328 40.494-10.851-2.499-9.328-40.494 10.851z'
                    fill='#CDD7E0'
                />
                <mask id='d' maskUnits='userSpaceOnUse' x='146' y='120' width='57' height='26'>
                    <path d='M146.276 134.387l2.849 10.634 53.595-14.36-2.85-10.634-53.594 14.36z' fill='#fff' />
                </mask>
                <g mask='url(#d)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M171.977 132.236l.454 1.696 7.107-1.904-.455-1.696-7.106 1.904z'
                        fill='#743200'
                    />
                </g>
                <mask id='e' maskUnits='userSpaceOnUse' x='157' y='128' width='19' height='13'>
                    <path d='M174.162 128.888l1.835 6.85-16.371 4.386-1.835-6.849 16.371-4.387z' fill='#fff' />
                </mask>
                <g mask='url(#e)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M156.461 140.972l-1.835-6.849 5.211-1.396c7.911-2.12 14.736-2.305 15.242-.414.507 1.891-5.495 5.143-13.406 7.263l-5.212 1.396z'
                        fill='#F9D300'
                    />
                </g>
                <path
                    d='M189.706 128.397c.18.675-1.977 1.839-4.818 2.6l-1.077.29c.049.189-.557.516-1.355.73-.799.214-1.488.234-1.539.044-.004-.015-.004-.031 0-.048-2.123.421-3.794.394-4.05-.108l-.024-.061c-.15-.561 1.315-1.459 3.446-2.184-.014-.012-.022-.026-.026-.041-.051-.19.555-.517 1.355-.731.799-.214 1.488-.234 1.539-.045l1.076-.288c2.842-.761 5.292-.832 5.473-.158z'
                    fill='#6D2C00'
                />
                <path
                    d='M194.851 127.019c.047.176-.226.419-.699.665-.256.133-.342.257-.174.299.369.093.383.316-.043.619-.383.273-1.041.553-1.765.77-.416.126-.713.287-.754.405-.065.188-.397.437-.977.697-.706.318-1.607.576-2.397.709-.358.06-.748.195-.984.329-.437.247-1.092.505-1.843.706-.601.161-1.166.26-1.625.296-.351.026-.825.159-1.145.311-.222.105-.484.212-.783.317-1.006.351-2.178.571-2.873.537-.214-.01-.369-.041-.47-.088-.129-.06-.457-.04-.832.046l-.142.036-.011.003c-1.445.387-2.688.417-2.74.061-.016-.106.083-.236.268-.376.207-.157.265-.29.164-.376l2.668-.715c.682.088 1.717.019 2.92-.2l.303-.057c-.004.017-.004.033 0 .048.051.19.74.17 1.539-.044.127-.034.249-.071.364-.11-.289-.025-.472-.098-.505-.22-.09-.338.988-.92 2.409-1.3-.09-.338.988-.919 2.409-1.3-1.353.362-2.529.412-2.715.124l-.021-.045c-1.421.38-2.646.416-2.736.078-.033-.123.089-.278.326-.444-.117.024-.242.054-.369.088-.8.214-1.406.541-1.355.731.004.015.012.029.026.041-1.186.403-2.166.86-2.776 1.283l-.144.105-.595.159-2.075.558c.043-.122-.062-.208-.314-.238-.291-.035-.459-.124-.446-.271.022-.277.736-.701 1.749-1.043.241-.081.48-.152.712-.213.425-.112.758-.278.847-.405.059-.086.166-.182.326-.288.577-.385 1.733-.796 2.807-.998.306-.058.582-.096.823-.116.354-.028.831-.15 1.148-.302.416-.199.954-.396 1.555-.557.756-.203 1.455-.307 1.958-.31.278-.001.69-.09 1.043-.22.238-.088.501-.174.788-.254 1.001-.281 2.002-.408 2.512-.316.144.026.242.066.297.118.086.079.438.065.845-.031.198-.046.399-.088.6-.123 1.038-.18 1.779-.121 1.812.146.01.08-.04.17-.136.266-.125.123-.009.195.289.182.532-.023.89.051.937.227z'
                    fill='#371F38'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M222.991 238.287l.453-8.638-57.872-3.033-.453 8.638 57.872 3.033z'
                    fill='#EFEFF0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M211.44 237.225l.393-7.5-43.725-2.292-.393 7.501 43.725 2.291z'
                    fill='#CDD7E0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M194.57 232.013l5.392 2.766-13.816-.724c-6.109-.32-11.015-1.467-10.957-2.561.057-1.094 5.055-1.721 11.164-1.401 4.581.24 8.26 1.1 8.217 1.92z'
                    fill='#371F38'
                />
                <mask id='f' maskUnits='userSpaceOnUse' x='165' y='226' width='59' height='13'>
                    <path d='M222.991 238.287l.448-8.551-57.872-3.033-.448 8.551 57.872 3.033z' fill='#fff' />
                </mask>
                <g mask='url(#f)' fillRule='evenodd' clipRule='evenodd' fill='#BB5602'>
                    <path d='M196.715 233.119l.052-.991-7.674-.402-.052.991 7.674.402z' />
                    <path d='M191.832 232.366c-.029.547-2.528.861-5.582.701l-2.765-.145c-3.055-.16-5.507-.733-5.478-1.28.028-.547 2.527-.861 5.581-.701l2.765.145c3.055.16 5.507.733 5.479 1.28z' />
                    <path d='M186.205 232.91c.859.045 1.549.206 1.541.36-.008.153-.711.242-1.57.197-.859-.045-1.549-.207-1.541-.36.008-.154.711-.242 1.57-.197zM186.322 230.681c.858.045 1.549.206 1.541.36-.008.154-.712.242-1.57.197-.859-.045-1.549-.206-1.541-.36.008-.154.711-.242 1.57-.197z' />
                </g>
                <mask id='g' maskUnits='userSpaceOnUse' x='177' y='230' width='15' height='4'>
                    <path
                        d='M182.867 232.868l2.704.142c2.986.156 5.431-.183 5.461-.759.031-.576-2.366-1.17-5.352-1.326l-2.704-.142c-2.986-.156-5.431.184-5.461.759-.031.576 2.366 1.17 5.352 1.326z'
                        fill='#fff'
                    />
                </mask>
                <g mask='url(#g)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M177.615 230.45c4.162.218 7.502 1.045 7.459 1.848-.042.802-3.45 1.276-7.611 1.058-4.162-.219-7.502-1.046-7.46-1.848.042-.803 3.45-1.276 7.612-1.058z'
                        fill='#371F38'
                    />
                </g>
                <mask id='h' maskUnits='userSpaceOnUse' x='193' y='229' width='19' height='8'>
                    <path d='M193.489 235.256l.289-5.507 17.677.926-.288 5.508-17.678-.927z' fill='#fff' />
                </mask>
                <g mask='url(#h)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M214.873 230.854l-.289 5.508-5.627-.295c-8.542-.448-15.403-2.044-15.323-3.565.079-1.521 7.069-2.39 15.612-1.943l5.627.295z'
                        fill='#B75FD0'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M129.337 229.098l.302 8.644 55.452-1.937-.302-8.644-55.452 1.937z'
                    fill='#EFEFF0'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M140.443 229.165l.263 7.507 41.896-1.463-.262-7.507-41.897 1.463z'
                    fill='#CDD7E0'
                />
                <mask id='i' maskUnits='userSpaceOnUse' x='129' y='227' width='57' height='11'>
                    <path d='M129.337 229.098l.299 8.557 55.452-1.936-.299-8.558-55.452 1.937z' fill='#fff' />
                </mask>
                <g mask='url(#i)'>
                    <mask id='j' maskUnits='userSpaceOnUse' x='140' y='229' width='22' height='7'>
                        <path d='M161.735 229.274l.207 5.915-20.949.731-.206-5.914 20.948-.732z' fill='#fff' />
                    </mask>
                    <g mask='url(#j)' fillRule='evenodd' clipRule='evenodd'>
                        <path d='M154.831 231.851l.04 1.138 7.353-.257-.04-1.137-7.353.256z' fill='#F38C00' />
                        <path
                            d='M136.485 236.025l-.199-5.687 5.392-.188c8.185-.286 14.865.756 14.92 2.326.055 1.57-6.536 3.075-14.721 3.361l-5.392.188z'
                            fill='#6FDFB7'
                        />
                    </g>
                    <path
                        d='M173.848 231.707c.022.646-2.796 1.268-6.294 1.391l-1.326.046c.006.181-.786.357-1.77.391-.984.034-1.787-.085-1.793-.267 0-.014.004-.029.013-.043-2.582-.043-4.512-.402-4.658-.91l-.009-.055c-.019-.537 1.925-1.057 4.59-1.288-.011-.013-.017-.028-.018-.042-.006-.182.786-.357 1.77-.392.984-.034 1.787.085 1.793.267l1.326-.046c3.499-.122 6.353.302 6.376.948z'
                        fill='#FA8100'
                    />
                    <path
                        d='M159.051 231.574l-.1.033c-.04.013-.078.026-.114.039-.068.024-.132.049-.192.074-.034.014-.066.028-.098.042l-.027.014c.362-.086.882-.15 1.461-.17l2.353-.082c1.1-.039 1.997.095 2.004.298l.015.434c.007.203-.879.399-1.978.437l-2.353.082c-1.099.039-1.997-.095-2.004-.298l-.015-.434c-.003-.096.192-.19.513-.266.041-.02.084-.039.129-.057.06-.025.124-.05.192-.074.067-.024.139-.048.214-.072zm14.797.133l-.005.055c-.134.626-2.891 1.217-6.289 1.336l.273-.012c.589-.332 2.104-.615 3.94-.716l.158-.008c-.766-.128-1.237-.318-1.245-.544-.008-.227.45-.449 1.207-.631l-.161.004c-1.84.027-3.372-.15-3.98-.441-.091.003-.182.006-.274.009l.298-.009c3.361-.089 6.056.33 6.078.957z'
                        fill='#371F38'
                    />
                </g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M259.418 238.371l.426-8.638L204.426 227l-.426 8.639 55.418 2.732z'
                    fill='#F1F1F2'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M248.357 237.37l.37-7.502-41.872-2.065-.369 7.502 41.871 2.065z'
                    fill='#CDD7E0'
                />
                <mask id='k' maskUnits='userSpaceOnUse' x='204' y='227' width='56' height='12'>
                    <path d='M259.418 238.371l.422-8.552-55.418-2.733-.422 8.553 55.418 2.732z' fill='#fff' />
                </mask>
                <g mask='url(#k)'>
                    <mask id='l' maskUnits='userSpaceOnUse' x='227' y='229' width='22' height='8'>
                        <path d='M227.15 235.471l.291-5.91 20.936 1.032-.292 5.911-20.935-1.033z' fill='#fff' />
                    </mask>
                    <g mask='url(#l)' fillRule='evenodd' clipRule='evenodd'>
                        <path d='M234.246 233.484l.056-1.137-7.348-.362-.056 1.136 7.348.363z' fill='#BC6100' />
                        <path
                            d='M252.878 230.867l-.28 5.684-5.388-.266c-8.181-.403-14.75-2.003-14.672-3.572.077-1.569 6.772-2.515 14.952-2.111l5.388.265z'
                            fill='#0078C8'
                        />
                    </g>
                    <path
                        d='M214.555 231.875c.034-.678 3.038-1.081 6.711-.9l1.392.069c.009-.191.854-.304 1.887-.253 1.033.051 1.863.247 1.853.437 0 .016-.007.031-.018.045 2.704.273 4.696.821 4.797 1.367l.004.055c-.028.563-2.108.937-4.919.943.011.015.016.03.015.045-.009.191-.854.304-1.887.253-1.033-.05-1.863-.246-1.853-.437l-1.392-.069c-3.673-.181-6.623-.877-6.59-1.555z'
                        fill='#BB5602'
                    />
                    <path
                        d='M230.708 232.204l.048.025.033.018c.053.03.1.059.142.089.013.009.024.017.035.026.035.026.065.052.092.079l.027.027c.029.034.048.062.063.089.01.02.019.041.024.061.007.025.01.051.009.077l-.004-.057c-.001-.007-.003-.013-.005-.02-.006-.021-.014-.041-.024-.061-.006-.01-.012-.021-.02-.032l-.038-.05c-.01-.012-.021-.023-.032-.034-.027-.027-.057-.053-.092-.079-.011-.009-.023-.017-.035-.026l.035.026c-.05-.039-.11-.077-.177-.115-.01-.005-.021-.011-.032-.017l.032.017c-.032-.018-.066-.035-.101-.053l.069.036c-.07-.038-.147-.075-.233-.112-.062-.027-.129-.054-.2-.08-.064-.024-.132-.048-.203-.072-.033-.011-.067-.022-.101-.033l.101.033c-.048-.016-.097-.032-.148-.047l.047.014c-.382-.121-.846-.235-1.375-.337-.421-.082-.884-.156-1.38-.221-.204-.027-.413-.052-.628-.076-.107-.011-.216-.023-.326-.033l-.244-.024c-.134-.012-.27-.024-.408-.034-.158-.013-.317-.025-.479-.035l-.293-.018c.262.015.52.033.772.053.127.01.252.02.376.031l.032.003c.193.018.384.037.57.057.215.024.424.049.628.076.496.065.958.139 1.38.221.508.098.956.207 1.328.323.016.004.031.009.047.014.034.011.068.022.101.033.071.024.138.048.203.072.071.026.138.053.2.08.056.024.108.048.157.073l.027.013zm-9.563 1.226l-.155-.008c-3.6-.192-6.467-.879-6.434-1.547l.009-.055c.187-.644 3.128-1.021 6.701-.845l-.286-.013.286.013-.287-.012c-.37.169-1.059.295-1.944.361 1.349.231 2.23.559 2.214.881-.016.322-.926.561-2.293.659l.003.001.086.014c.75.135 1.345.3 1.703.477l.11.059c.095.005.191.011.287.015z'
                        fill='#6D2C00'
                    />
                </g>
            </g>
            <defs>
                <clipPath id='clip0'>
                    <path fill='#fff' transform='translate(50 40)' d='M0 0h300v200H0z' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default DetectivesPolaroids;
